import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';
import Swal from 'sweetalert2'; // Import SweetAlert2
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2

import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import LoadingTable from '../../components/LoadingTable';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import { useThemeContext } from '../../../fetchdata/ThemeContext';
import getDecryptData from '../../../helpers/getDecryptData';

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components


function UserAllPayments() {


    const { getAuth,dataAuth } = useThemeContext();
  
        const decryptdatajson = getDecryptData();
    const UserId = decryptdatajson?._id;

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [employees, setEmployees] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchData = async () => {
 
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/all-payments?page=${currentPage}&limit=${limit}&search=${searchTerm}&userId=${UserId}`);
      setData(response.data.Transaction);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };


  // Function to handle delete
  const handleDelete = (categoryId) => {
    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        popup: 'custom-swal-popup', // Add a class to the entire dialog
        confirmButton: 'btn-danger', // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {


        axiosInstance.delete(`/admin/delete-tax/${categoryId}`)
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Deleting Taxes Success!");
          })
          .catch((error) => {
            console.error('Error Taxes data:', error);
            toast.error("Error Taxes data");
          });
      }
    });
  };

  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1)
    setSearchTerm(e.target.value);


  };

  const handleSearch = () => {
    fetchData(currentPage);

  };

  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  }

  const downloadInvoice_old = async (id) => {
    try {
      const response = await toast.promise(
        axiosInstance.post(
          `/download-invoice`,

          { invoiceId: id },
          {
            responseType: "blob", // Important for handling binary data
          }
        ),
        {
          loading: "Invoice Downloading...", // Loading message
          success: "Invoice Downloaded!", // Success message
          error: "Failed to Invoice Download.", // Error message
        }
      );

      // Create a link element and simulate a click to download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoice.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading the invoice:", error);
    }
  };


      // Function to handle delete
  const handleWithdrawal = (userId) => {
    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this withdrawal!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, withdrawal it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        popup: 'custom-swal-popup', // Add a class to the entire dialog
        confirmButton: 'btn-primary', // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {
 
    axiosInstance.get(`/admin/withdrawal/${userId}`) 
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Withdrawal Points Successfully!");
          })
          .catch((error) => {
            console.error('Error Mark Done:', error);
            toast.error(error.response.data.message || 'Error Withdrawal Points!');
          });
      }
    });
  };

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state

    const [formData, setFormData] = useState({
    userId: null,
    type: 0,
    note: `Credits Added By ${decryptdatajson.username} `,
    amount: 0,
    wallet: 0,
    trans: 0,
  });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
    const prices = [ 2000, 3000, 4000 ,6000];
const setWalletAmount = (amt) => {
    setFormData((prevData) => ({
      ...prevData,
      wallet: amt,
    }));
  };

    const SubmitOrderWallet = async () => {
        if (Number(formData.wallet) < Number(getAuth.limit) ) {
      toast.error(`Minimum wallet amount is ${getAuth.limit}`);
      setSubmitLoading(true);
      return;
    }
      try {
      const Local = getAuth.Local;
       const userId = getAuth._id;
      const amount = Number(formData.wallet);

      // Send request to backend to initiate PhonePe payment
      const { data } = await axiosInstance.post("/checkout-wallet", {
        amount,
        userId,
        note: formData.note,
        Local,
      });
            if (data.success) {
             toast.success("Add Found Successfully!");
              fetchData(currentPage);
              dataAuth();
            }

    } catch (error) {
     toast.error("Payment request failed! Please try again.");
    }

  }

    const downloadInvoice = async (id,status) => {
    // if(status !== 1){
    //   toast.error(`Sorry, the payment status is pending, and the invoice cannot be downloaded.`);
    //   return null;
    // }
    try {
      const response = await toast.promise(
        axiosInstance.post(
          `/download-invoice-wallet`,

          { invoiceId: id },
          {
            responseType: "blob", // Important for handling binary data
          }
        ),
        {
          loading: "Invoice Downloading...", // Loading message
          success: "Invoice Downloaded!", // Success message
          error: "Failed to Invoice Download.", // Error message
        }
      );

      // Create a link element and simulate a click to download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoice.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading the invoice:", error);
    }
  };


  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">


 <div className="modal fade" id="walletModal">
              <div className="bg-dark-shadow-fix "></div>
              <div className="modal-dialog " role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Money</h5>
                    <button className="btn-close" data-bs-dismiss="modal">
                      <i className="fa-solid fa-xmark" />
                    </button>
                  </div>
                  <div className="modal-body bg-light">
                    <div className="mb-2 input-group input-group-icon">
                      <span className="input-group-text">
                        <div className="input-icon">
                          <i className="ri-wallet-fill"></i>
                        </div>
                      </span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Amount"
                        id="wallet"
                        value={formData.wallet !== 0 ? formData.wallet : ""}
                        name="wallet"
                        onChange={handleChange}
                      />
                    </div>
                    {/* 18% gst will be added */}
                    <div className="d-block mt-3 ">
                      {prices.map((price) => (
                        <button
                          key={price}
                          onClick={() => setWalletAmount(price)}
                          className="badge py-2 px-3 badge-pill badge-dark me-2 rounded-sm font-15 bg-dark"
                        >
                          {price}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-sm btn-danger light"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-sm btn-primary"
                      onClick={SubmitOrderWallet}
                    >
                      Pay Now
                    </button>
                  </div>
                </div>
              </div>
            </div>



          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4"> All Payments</h1>
            </div>
            <div>
               <Link
               className='btn btn-primary'
           to={`/all-transaction`}
                // onClick={() => handleWithdrawal(UserId)}
              >
                 Go back
              </Link>
            </div>
          </div>
        </div>


        <div className="card">
          <div className="table-responsive py-4">

            {loading ? (
              <LoadingTable />
            ) : (
              <>


                <div className="datatable-top">
                  <div className="datatable-dropdown">
                    <label>
                      <select className="datatable-selector" value={limit} onChange={(e) => {
                        setlimit(parseInt(e.target.value, 10));
                        setCurrentPage(1); // Reset current page to 1 when the limit changes
                      }} >
                        <option value={5}>5</option>
                        <option value={10} >
                          10
                        </option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                      </select>{" "}

                      entries per page
                    </label>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div className="datatable-search">
                      <input
                        className="datatable-input"
                        type="text"
                        placeholder="Search..." value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </div>
                    <button className="btn btn-primary" onClick={handleSearch}> Search
                    </button>

                  </div>
                </div>





                <table className="table table-flush">
                  <thead>
                    <tr>
                      <th>Razorpay ID</th>
                      <th> Date</th>
                      <th> Amount</th>
                         <th> Status</th>

                       <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((row, index) => (
                      <tr key={index}>
                        <td>{row.razorpay_order_id}</td>
                        <td>{formatDate(row.createdAt)}</td>

                        <td> {Math.abs(row.totalAmount)}</td>
                        <td>{row.payment === 1 ? <span className='bg-success text-white px-2 py-1 rounded'> Success </span> : 
                        <span className='bg-danger text-white px-2 py-1 rounded' > Failed </span> }</td>
                        <td>
                        <button
                          className="btn btn-primary btn-sm text-white"
                          onClick={() => downloadInvoice(row._id,row.payment)}
                          disabled={row.payment !== 1}
                        >
                          <i className="ri-file-download-fill me-2 fw-light"></i>
                          Invoice
                        </button>

                        </td>

                        


                      </tr>
                    ))}
                  </tbody>
                </table>


                <div className="datatable-bottom">
                  <div className="datatable-info">  </div>
                  <nav className="datatable-pagination">
                    <ul class="datatable-pagination-list">

                      <li className={`datatable-pagination-list-item ${currentPage === 1 ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button data-page="1" class="datatable-pagination-list-item-link" onClick={handlePreviousPage} disabled={loading || currentPage === 1}
                          aria-label="Page 1">‹</button>
                      </li>
                      <li>
                        <div className="datatable-info py-1 px-3">Showing  Page{' '}
                          <strong>
                            Showing Page  {currentPage} of {totalPages}

                          </strong>{' '} </div>
                      </li>
                      <li className={`datatable-pagination-list-item ${currentPage === totalPages ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button data-page="2" class="datatable-pagination-list-item-link" aria-label="Page 2" onClick={handleNextPage} disabled={loading || currentPage === totalPages}
                        >  {loading ? 'Loading...' : '›'} </button>
                      </li>
                    </ul></nav>
                </div>



              </>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default UserAllPayments;
